import { useEffect } from "react";
import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";
import { logsConfig, rumConfig } from "./config";

export default function DatadogInit() {
  useEffect(() => {
    if (!datadogRum.getInitConfiguration()) datadogRum.init(rumConfig);
    if (!datadogLogs.getInitConfiguration()) datadogLogs.init(logsConfig);
  }, []);

  return null;
}
